import React from "react";

const Footer = () => {
    return (
        <footer className="relative bg-[rgb(20,23,30)] text-gray-300 h-24 flex items-center">
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
                {/* Menü Linkleri */}
                <nav className="flex gap-8 text-[11px] tracking-[0.18em] uppercase text-gray-400">
                    <a href="#hakkimizda" className="hover:text-white transition-colors">
                        HAKKIMIZDA
                    </a>
                    <a href="#galeri" className="hover:text-white transition-colors">
                        GALERİ
                    </a>
                    <a href="#referanslar" className="hover:text-white transition-colors">
                        REFERANSLAR
                    </a>
                    <a href="#iletisim" className="hover:text-white transition-colors">
                        İLETİŞİM
                    </a>
                </nav>
            </div>
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
                {/* Copyright */}
                <p className="text-[11px] font-semibold tracking-[0.15em] whitespace-nowrap text-gray-400">
                    © 2025 KAHRAMAN AHŞAP MERDİVEN
                </p>
            </div>
        </footer>
    );
};

export default Footer;
